export enum PHASES {
  START = 'Start',
  COLLECT_NAMES = 'CollectNames',
  COUNTDOWN = 'Countdown',
  DRAW = 'Draw',
  REVEAL = 'Reveal',
  RESULT = 'Result',
}
